import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import MultiColumnLayout from '../../Shared/MultiColumnLayout';

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) => colourOverrideBackground || themeGet('colors.maroon')};
`;

export const StyledContainer = styled(Container)`
  max-width: 1920px;
  padding: 50px 0 60px;

  // * Title styles
  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    color: ${themeGet('colors.text-primary')};
    text-align: center;

    margin-bottom: 52px;

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 90px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;
  }
`;

export const Columns = styled(MultiColumnLayout)``;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  p {
    color: ${themeGet('colors.white')};
    margin-bottom: 45px;

    font-size: 16px;
    letter-spacing: 0.2px;
    line-height: 28px;
  }

  h3,
  p {
    /* for IE */
    width: 100%;
  }

  ${Wrapper}.text-dark & {
    p {
      color: ${themeGet('colors.text-secondary')};
    }
  }
  ${Wrapper}.text-light & {
    p {
      color: ${themeGet('colors.text-primary')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: column;
  }
`;

export const StyledImage = styled(Image)`
  /* width: auto; */
  /* height: 207px; */
  height: 100%;
  width: 100%;
  max-height: 207px;
  max-width: 207px;

  margin: 0 auto 35px;

  ${Block}.left &, ${Block}.Left & {
    margin: 0 0 35px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    /* height: 144px; */
    max-height: 144px;
    max-width: 144px;
    margin-right: 24px;

    ${Block}.left &, ${Block}.Left & {
      margin-right: 24px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    /* height: 180px; */
    max-height: 180px;
    max-width: 180px;
    margin: 0 auto 39px;

    ${Block}.left &, ${Block}.Left & {
      margin: 0 0 39px;
    }
  }
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* for IE */
  width: 100%;

  p {
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    margin-top: auto;
    color: ${themeGet('colors.white')};
  }

  ${Wrapper}.text-dark & {
    a {
      color: ${themeGet('colors.text-secondary')};
    }
  }
  ${Wrapper}.text-light & {
    a {
      color: ${themeGet('colors.text-primary')};
    }
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 15px;
  /* for IE */
  width: 100%;

  > h2,
  > h3,
  > h4,
  > h5,
  > h6,
  > p {
    color: ${themeGet('colors.white')};
    font-weight: ${themeGet('font-weights.bold')};
    text-align: center;
    margin-bottom: 0;

    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;

    ${Block}.left &, ${Block}.Left & {
      text-align: left;
    }

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    > h2,
    > h3,
    > h4,
    > h5,
    > h6,
    > p {
      text-align: left;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    > h2,
    > h3,
    > h4,
    > h5,
    > h6,
    > p {
      font-size: 22px;
      line-height: 32px;
      letter-spacing: -0.5px;
    }
  }
`;

export const SubTitle = styled.h3`
  color: ${themeGet('colors.white')};
  text-align: center;

  ${Block}.left &, ${Block}.Left & {
    text-align: left;
  }

  ${Wrapper}.text-dark & {
    color: ${themeGet('colors.text-secondary')};
  }
  ${Wrapper}.text-light & {
    color: ${themeGet('colors.text-primary')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    text-align: left;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const LocationTag = styled.p`
  && {
    font-size: 18px;
    letter-spacing: -0.2px;
    line-height: 32px;
    font-weight: normal;
    margin: 0;
  }
`;
